import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router";

import { User } from "../../assets/icons";
import logo from "../../assets/images/mtab-logo.svg";
import { TEST_USER } from "../../config";
import { useApi } from "../../context/context";
import ApiNotifications from "../Notifications/ApiNotifications";

import styles from "./Header.module.scss";

const Header = () => {
  const {
    isVerified,
    user,
    companyId,
    company,
    canAccessProjects,
    canAccessArtWarehouse,
    hasInvoiceAccess
  } = useApi();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const isTestUser = user?.Email === TEST_USER.userId;
  const isCompanyLoaded = Boolean(companyId && company);

  // TODO: revisit this logic (it's the logic to create hamburger menu on mobile)
  const toggleMenu = () => {
    const menu = document.querySelector("#tool-menu");
    const spans = menu.querySelectorAll("button > span");

    if (menu.classList.contains(`${styles.open}`)) {
      menu.classList.remove(`${styles.open}`);
    } else {
      menu.classList.add(`${styles.open}`);
    }
    for (let i = 0; i < spans?.length; i++) {
      if (spans[i].classList.contains(`${styles.change}`)) {
        spans[i].classList.remove(`${styles.change}`);
      } else {
        spans[i].classList.add(`${styles.change}`);
      }
    }
  };

  return (
    <header>
      <Link to="/">
        <img src={logo} className={styles.logo} alt="logo" />
      </Link>
      <nav>
        {isVerified && (
          <ul className={styles.mainMenu}>
            {isCompanyLoaded && canAccessProjects && (
              <li>
                <Link
                  to="/projects"
                  className={
                    location?.pathname?.includes("/project") ||
                    location?.pathname?.includes("/projects")
                      ? styles.active
                      : styles.notActive
                  }
                >
                  {t("projects")}
                </Link>
              </li>
            )}
            {isCompanyLoaded && hasInvoiceAccess && (
              <li>
                <Link
                  to="/invoices"
                  className={
                    location?.pathname?.includes("/invoices")
                      ? styles.active
                      : styles.notActive
                  }
                >
                  {t("invoices")}
                </Link>
              </li>
            )}
            {canAccessArtWarehouse && (
              <li className={styles.artWarehouseItem}>
                <Link
                  to="/art-warehouse"
                  className={
                    location?.pathname?.includes("/art-warehouse")
                      ? styles.active
                      : styles.notActive
                  }
                >
                  {t("artWarehouse")}
                </Link>
              </li>
            )}
          </ul>
        )}
        <button className={styles.burger} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={styles.toolMenu} id="tool-menu">
          {isCompanyLoaded && canAccessProjects && (
            <ApiNotifications isUserVerified={isVerified} />
          )}
          {/* <Notifications
            notifyList={notifyList}
            status={status}
            isUserVerified={isVerified}
            setNotifications={setNotifications}
          /> */}
          {isVerified && isTestUser && (
            <li onClick={() => navigate("/login-test")}>Switch company</li>
          )}
          {isVerified && (
            <li
              className={styles.profileToolItem}
              onClick={() => navigate("/profile")}
            >
              <User className={styles.user} />
              {user?.FirstName}
            </li>
          )}
          {/* TODO: Temporarily hiding the language */}
          {/* <li className={styles.language}>
            {i18n.language}
            <Arrow className={styles.arrow} />
            <LanguageDropdown changeLanguage={i18n.changeLanguage} />
          </li> */}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
